fragment showcaseButton on LinkData {
    url
    label
    type
}